// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","pageTitle":"_20UPXG204PodbfMurdDeCB"};